module.exports = __webpack_public_path__ + "img/4.1cba8ab4.png";